module.exports = __webpack_public_path__ + "static/media/back-arrow.c6976e4d.svg";